import { useEffect } from "react";

const CONTENT = {
  terms: {
    title: "Kiralama Koşulları",
    sections: [
      { h: "Genel Şartlar", p: "Araç kiralamak için sürücünün en az 21 yaşında olması ve en az 1 yıllık geçerli bir sürücü belgesine sahip olması gerekir. Araç sınıfına göre yaş ve ehliyet şartları değişebilir." },
      { h: "Kiralama Süresi", p: "Minimum kiralama süresi 1 gündür. Kiralama, aracın teslim alındığı saatten itibaren 24 saatlik dilimler halinde hesaplanır." },
      { h: "Yakıt Politikası", p: "Araç, teslim alındığı yakıt seviyesiyle iade edilmelidir. Aksi halde eksik yakıt ücreti tahsil edilir." },
      { h: "Sigorta ve Güvence", p: "Tüm araçlarımız zorunlu trafik sigortası ve kasko kapsamındadır. Ek güvence paketleri talep üzerine sunulur." },
      { h: "Teslim ve İade", p: "Alış ve iade noktaları rezervasyon sırasında belirlenir. Farklı noktada teslim seçeneği ek ücrete tabi olabilir." },
    ],
  },
  privacy: {
    title: "Gizlilik Politikası",
    sections: [
      { h: "Toplanan Bilgiler", p: "Rezervasyon ve iletişim formları aracılığıyla ad, telefon, e-posta gibi kişisel bilgileriniz talebinizi işleme almak amacıyla toplanır." },
      { h: "Bilgilerin Kullanımı", p: "Bilgileriniz yalnızca kiralama sürecinin yürütülmesi, sizinle iletişim kurulması ve hizmet kalitesinin artırılması için kullanılır." },
      { h: "Üçüncü Taraflarla Paylaşım", p: "Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz." },
      { h: "Veri Güvenliği", p: "Verileriniz uygun teknik ve idari tedbirlerle korunmaktadır." },
    ],
  },
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    sections: [
      { h: "Veri Sorumlusu", p: "6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında veri sorumlusu VoyaCar Rental'dır." },
      { h: "İşleme Amacı", p: "Kişisel verileriniz; araç kiralama talebinizin oluşturulması, rezervasyon süreçlerinin yürütülmesi ve sizinle iletişim kurulması amacıyla işlenir." },
      { h: "Haklarınız", p: "Kanun'un 11. maddesi uyarınca kişisel verilerinize erişme, düzeltme, silme ve işlenmesine itiraz etme haklarına sahipsiniz. Taleplerinizi iletişim kanallarımızdan bize iletebilirsiniz." },
      { h: "Saklama Süresi", p: "Verileriniz, işleme amacının gerektirdiği ve yasal mevzuatın öngördüğü süre boyunca saklanır." },
    ],
  },
  cookie: {
    title: "Çerez Politikası",
    sections: [
      { h: "Çerez Nedir?", p: "Çerezler, web sitemizi ziyaret ettiğinizde cihazınıza kaydedilen küçük metin dosyalarıdır." },
      { h: "Kullanım Amacı", p: "Çerezleri; site deneyiminizi geliştirmek, tercihleri hatırlamak ve site kullanımını analiz etmek için kullanırız." },
      { h: "Çerez Tercihleri", p: "Site üzerindeki çerez bildirimi aracılığıyla çerez tercihlerinizi kabul edebilir veya reddedebilirsiniz. Tarayıcı ayarlarınızdan da çerezleri yönetebilirsiniz." },
    ],
  },
};

export default function LegalPage({ pageKey }) {
  const data = CONTENT[pageKey];
  useEffect(() => { document.title = `${data.title} | VoyaCar Rental`; window.scrollTo(0, 0); }, [data.title]);
  return (
    <div>
      <div className="bg-[#171717] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold">{data.title}</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        {data.sections.map((s, i) => (
          <div key={i} data-testid={`legal-section-${i}`}>
            <h2 className="text-xl font-semibold text-[#171717] mb-2">{s.h}</h2>
            <p className="text-neutral-600 leading-relaxed">{s.p}</p>
          </div>
        ))}
        <p className="text-xs text-neutral-400 pt-6 border-t">Bu metin bilgilendirme amaçlıdır ve gerektiğinde güncellenebilir.</p>
      </div>
    </div>
  );
}
